<!-- Information Modal -->
<div class="modal-header">
    <h5 class="modal-title">Information</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
    >
        <i class="pbslm-close-thin-cross close-img"></i>
    </button>
</div>
<div class="modal-body">
    {{ message }}
</div>
<div class="modal-footer">
    <button (click)="activeModal.dismiss('Cross click')" class="btn btn-secondary" type="button">
        OK
    </button>
</div>
